'use client';

import { useEffect } from 'react';
import useEnv from './useEnv';

export default function useClientMetadata(path?: string | null) {
  const { chewyBaseUrl } = useEnv() || {};

  useEffect(() => {
    if (!path) {
      return;
    }

    let cancelled = false;

    void import('@/utils/seo/seoHelpers').then(({ getSEOMetadata }) => {
      if (cancelled) {
        return;
      }

      const { title, description, canonical } = getSEOMetadata(path, chewyBaseUrl);
      const descriptionTag = document.head.querySelector<HTMLMetaElement>('meta[name="description"]');
      const canonicalTag = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      canonicalTag?.setAttribute('href', canonical);

      document.title = title;
      descriptionTag?.setAttribute('content', description);
    });

    return () => {
      cancelled = true;
    };
  }, [chewyBaseUrl, path]);
}
